export default {"src":"/_next/static/media/check-circle.419997df.svg","height":52,"width":52,"blurWidth":0,"blurHeight":0};